import React, { useState } from "react";
import "./css/mycart.css"

const Mycart = ({disabled,...props}) => {
   
    const [comVar, setcomVar] = useState(props.cart);
   

    return(
        <div>
            <p id="pitem " className="removemar"> {props.name} <br/><br/>
                    <input disabled={disabled} className={`ip cartBtn ${comVar.cart.decBlock? 'disabledthisd': ''}`} type="button" value="-" onClick={()=>props.decrementQuantity(comVar,props.index)} />
                    <input disabled={disabled} className="ip cartBtn inputfield" id="tx-w" type="text" value={comVar.cart.quantity} readOnly/>
                    <input disabled={disabled} className={`ip cartBtn ${comVar.cart.incBlock? 'disabledthisd': ''}`} type="button" value="+" onClick={()=>props.incrementQuantity(comVar,props.index)} />
            </p>  
        </div>
    )
}

export default Mycart;